import Button, { ButtonProps } from '@anm/components/buttons/Button';
import getPageNameFromUrl from '@anm/helpers/getPageNameFromUrl';
import toCamelCase from '@anm/helpers/string/toCamelCase';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import routes from '../../../../routes';
import { appMetaSelectors } from '../../../../store/modules/appMeta';

import { getParams, getRoute } from './helpers';

const { Link } = routes;

const SignUpButton: FC<ButtonProps> = ({ ...buttonProps }) => {
  const path = useSelector(appMetaSelectors.selectAppMetaPath);
  const product = useSelector(appMetaSelectors.selectAppMetaProduct);
  const pageName = getPageNameFromUrl(path);
  const dataAttr = toCamelCase(`signup button on ${pageName} page`);
  const paramsObject = getParams();

  return (
    <Link route={getRoute(product)} params={paramsObject as {}}>
      <a>
        <Button {...buttonProps} data-button={dataAttr}>
          Sign Up
        </Button>
      </a>
    </Link>
  );
};

export default SignUpButton;
